import { ExtendedAreaModels } from '@bpd-library/utilities';
import { PropertyFilterProps } from '@features/properties/components/property-filter';

import { setApartmentFilters } from './apartments';
import { setDistrictsFilters } from './districts';
import { setLivingAreaFilters } from './living-area';
import { setPlotAreaFilters } from './plot-area';
import { setPriceFilters } from './price';
import { setProjectPhasesFilters } from './project-phases';
import { setPropertyTypesFilters } from './property-types';
import { setRentalFilter } from './rental';
import { setRoomFilters } from './rooms';
import { setStatusFilter } from './status';
import { setSunDirectionFilter } from './sun-direction';

export interface Filters {
    [key: string]: PropertyFilterProps;
}

export const constructFilters = async (
    data: ExtendedAreaModels,
    { allProjectsSold }: { allProjectsSold?: boolean },
) => {
    const urlHasParameters = !!window.location.search;
    const applyDefaultSettings = !urlHasParameters;

    const filters: Filters = {};

    await setApartmentFilters(data.apartmentBuildings, filters);
    await setDistrictsFilters(data.districts, filters);
    await setRentalFilter(data, filters, { applyDefaultSettings });
    await setProjectPhasesFilters(data, filters);
    await setPriceFilters(data, filters);
    await setStatusFilter(data, filters, { applyDefaultSettings, allProjectsSold });
    await setPropertyTypesFilters(data, filters);
    await setRoomFilters(data, filters);
    await setLivingAreaFilters(data, filters);
    await setPlotAreaFilters(data, filters);
    await setSunDirectionFilter(data, filters);

    return filters;
};
